import { Controller } from '@hotwired/stimulus';
import intlTelInput from 'intl-tel-input';

export default class extends Controller {
  static targets = ['input'];
  static values = {
    options: {
      initialCountry: 'ES',
      preferredCountries: ['ES', 'IT', 'FR'],
      strictMode: true,
      separateDialCode: true,
      formatOnDisplay: true,
      autoHideDialCode: false,
      nationalMode: false,
      utilsScript:
        'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
    },
  };

  connect() {
    this.instances = [];
    this.initTelInput();
  }

  onSubmit(_event) {}

  initTelInput() {
    this.inputTargets.forEach((input) => {
      if (input.parentElement.classList.contains('iti')) return;

      const options = { ...this.optionsValue };
      if (input.dataset.clubCountry) {
        options.initialCountry = input.dataset.clubCountry;
      }

      const instance = intlTelInput(input, options);
      this.instances.push(instance);

      this.dispatch('phoneInitialized', {
        detail: { instance: instance, input: input },
      });

      input.closest('form').addEventListener('submit', (e) => {
        if (
          instance.isValidNumber() &&
          [
            intlTelInputUtils.numberType.MOBILE,
            intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
          ].includes(instance.getNumberType())
        ) {
          input.value = instance.getNumber();
        }
      });
    });
  }
}
